module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_prl_r1.htm"
    }
  }, [_vm._v("PROLOGUE: The Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c01_r1.htm"
    }
  }, [_vm._v("1 Origins I: A. K. Sarvis, M.D.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c02_r1.htm"
    }
  }, [_vm._v("2 Origins II: George W. Hayduke")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c03_r1.htm"
    }
  }, [_vm._v("3 Origins III: Seldom Seen Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c04_r1.htm"
    }
  }, [_vm._v("4 Origins IV: Ms. B. Abbzug")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c05_r1.htm"
    }
  }, [_vm._v("5 The Wooden Shoe Conspiracy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c06_r1.htm"
    }
  }, [_vm._v("6 The Raid at Comb Wash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c07_r1.htm"
    }
  }, [_vm._v("7 Hayduke’s Night March")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c08_r1.htm"
    }
  }, [_vm._v("8 Hayduke and Smith at Play")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c09_r1.htm"
    }
  }, [_vm._v("9 Search and Rescue on the Job")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c10_r1.htm"
    }
  }, [_vm._v("10 Doc and Bonnie Go Shopping")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c11_r1.htm"
    }
  }, [_vm._v("11 Back to Work")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c12_r1.htm"
    }
  }, [_vm._v("12 The Kraken’s Arm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c13_r1.htm"
    }
  }, [_vm._v("13 Duologues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c14_r1.htm"
    }
  }, [_vm._v("14 Working on the Railroad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c15_r1.htm"
    }
  }, [_vm._v("15 Rest and Relaxation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c16_r1.htm"
    }
  }, [_vm._v("16 Saturday Night in America")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c17_r1.htm"
    }
  }, [_vm._v("17 The American Logging Industry: Plans and Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c18_r1.htm"
    }
  }, [_vm._v("18 Dr. Sarvis at Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c19_r1.htm"
    }
  }, [_vm._v("19 Strangers in the Night")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c20_r1.htm"
    }
  }, [_vm._v("20 Return to the Scene of the Crime")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c21_r1.htm"
    }
  }, [_vm._v("21 Seldom Seen at Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c22_r1.htm"
    }
  }, [_vm._v("22 George and Bonnie Carry On")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c23_r1.htm"
    }
  }, [_vm._v("23 At the Hidden Splendor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c24_r1.htm"
    }
  }, [_vm._v("24 Escape of the Depredator")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c25_r1.htm"
    }
  }, [_vm._v("25 Rest Stop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c26_r1.htm"
    }
  }, [_vm._v("26 Bridgework: Prolegomena to the Final Chase")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c27_r1.htm"
    }
  }, [_vm._v("27 On Your Feet: The Chase Begins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c28_r1.htm"
    }
  }, [_vm._v("28 Into the Heat: The Chase Continues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c29_r1.htm"
    }
  }, [_vm._v("29 Land’s End: One Man Left")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_c30_r1.htm"
    }
  }, [_vm._v("30 Edge of the Maze: The Chase Concluded")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795317361_epub_epl_r1.htm"
    }
  }, [_vm._v("EPILOGUE: The New Beginning")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30b925ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795317361_epub_toc_r1.vue
// module id = 72
// module chunks = 0